import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ReservationCancellationReason } from './reservation-cancellation-reason.model';
import { ReservationCancellationReasonService } from './reservation-cancellation-reason.service';
@Injectable()
export class ReservationCancellationReasonPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private reservationCancellationReasonService: ReservationCancellationReasonService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.reservationCancellationReasonService.find(id).subscribe(reservationCancellationReason => {
                this.reservationCancellationReasonModalRef(component, reservationCancellationReason);
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.reservationCancellationReasonModalRef(component, new ReservationCancellationReason());
            });
        }
    }

    reservationCancellationReasonModalRef(component: Component, reservationCancellationReason: ReservationCancellationReason): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.reservationCancellationReason = reservationCancellationReason;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason-popup.service.ts